import React from "react";
import { Col, Row, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AdminUserStat = ({ platform, type,currency }) => {
  const { t } = useTranslation();
  const stats =
    type === "booking"
      ? [
        { label: t("manageBooking.stats.totalBooking"), value: platform?.totalBooking || 0 },
        { label: t("manageBooking.stats.completeBooking"), value: platform?.completedBooking || 0 },
        { label: t("manageBooking.stats.yetToCheckIn"), value: platform?.yetToCheckin || 0 },
        // { label: "Thailand Booking", value: platform?.thaiHotel || 0 },
        // { label: "Vietnam Booking", value: platform?.vietHotel || 0 },
      ]
      :type==="transactions"?[
        { label: t("manageBooking.stats.totalPaidAmount","Total Amount"), value: (currency||"")+""+platform?.totalPaidAmount || 0 },
        { label: t("manageBooking.stats.totalHotelEarning","Total Hotel Earning"), value: (currency||"")+platform?.totalHotelEarning|| 0 },
        { label: t("manageBooking.stats.platformEarning","Total Platform Earning"), value: (currency||"")+platform?.totalPlatformEarning || 0 },
        { label: t("manageBooking.stats.totalVat","Total VAT"), value: (currency||"")+platform?.totalVat || 0 },
        {label: t("manageBooking.stats.totalGatewayCharges","Total Gateway Charges"), value: (currency||"")+platform?.totalGatewayCharges || 0 }

        // { label: "Thailand Booking", value: platform?.thaiHotel || 0 },
        // { label: "Vietnam Booking", value: platform?.vietHotel || 0 },
      ]: [
        { label: t("manageHotelAdmin.stats.totalHotelAdmin"), value: platform?.totalHotelAdmin || 0 },
        { label: t("manageHotelAdmin.stats.activeHotelAdmin"), value: platform?.activeHotel || 0 },
        { label: t("manageHotelAdmin.stats.inActiveHotelAdmin"), value: platform?.inActive || 0 },
        // {
        //   label: "Thailand Hotels Admin",
        //   value: platform?.thaiHotelAdmin || 0,
        // },
        // {
        //   label: "Vietnam Hotels Admin",
        //   value: platform?.vietHotelAdmin || 0,
        // },
      ];

  return (
    <Row className="g-4 py-2">
      {stats.map((item, idx) => (
        <Col key={idx} lg="4" md="4" sm="6">
          <Card
            className="text-center h-100"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "default",
              background: "#e8307a17",
              border: "0px",
            }}
          >
            <Card.Body>
              <Card.Title
                style={{ fontSize: "12px", fontWeight: 700, color: "#000000" }}
              >
                {item.label}
              </Card.Title>
              <Card.Text
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#E8307A",
                }}
              >
                {item.value}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AdminUserStat;
